import React , { Component } from 'react'
import images from '../config/images'
import { Header } from './LoggedIn/styles'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Profile from '../components/Profile/NavBarProfile'


class AppBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      popOverOpen: false,
      anchorEl: null,
      open: false,
      listModalOpen: false,
      listModalPurpose: null,
    }
  }
  handleLanguage = () => {
    let locale = localStorage.getItem('locale')
    if (locale == 'ja') {
      localStorage.setItem('locale', 'en')
    } else {
      localStorage.setItem('locale', 'ja')
    }
    window.location.reload()
  }

  toggleSidebar() {
    const value = this.props.openSidebar;
    this.props.toggleSidebar(!value)
  }

  render() {
    const { location, newSeminarUpgradeModal } = this.props;
    return(
      <div>
        <Header
          className="pr3 pl3 header-block"
          style={{ zIndex: 100, backgroundImage: 'linear-gradient(135deg, #4ac6c3 0%, #4ac6c3 30%, #e3fef1 90%, #e3fef1 100%)' }}
          title={
            <div className="row-custom">
              <div className="col-10-custom">
                {this.props.view === 'mobile' || this.props.view === 'sm-mobile' ? <img src={images.menuIcon} style={{ width: '24px' }} onClick={() => this.toggleSidebar()}/> : ''}
                <img src={images.fvlite_logo} alt="logo" style={{width: 120, cursor: 'pointer', marginLeft: '16px'}} onClick={() => {window.open('https://www.freshvoice.net/lite/')}}/>
              </div>
            </div>

          }
          showMenuIconButton={false}
          iconElementRight = {
          this.props.location !== '/fvdomain' ?
            <Profile location={location} newSeminarUpgradeModal={newSeminarUpgradeModal} handleLanguage={this.handleLanguage}
            />  :
            <div className="h-100 flex items-center pr3 pointer">
              <div onClick={this.handleLanguage}
              style={{padding: '20px', whiteSpace: 'nowrap',color: 'black'}}>
              {'日本語/English'}
              </div>
            </div>
          }
        />
      </div>
    )}
  }

export default AppBar



// WEBPACK FOOTER //
// src/layouts/AppBar.js